// hooks/useIsLoggedIn.ts
import { useEffect, useState } from "react";
import { authService } from "../services/auth.service";

export function useIsLoggedIn() {
  const [isLoggedIn, setIsLoggedIn] = useState(() => !!authService.getLoggedUser());

  useEffect(() => {
    const interval = setInterval(() => {
      const user = authService.getLoggedUser();
      setIsLoggedIn(!!user);
    }, 1000); // check every second

    return () => clearInterval(interval);
  }, []);

  return isLoggedIn;
}
